import { render } from "./ServiceBindList.vue?vue&type=template&id=7a8ac4c7"
import script from "./ServiceBindList.vue?vue&type=script&lang=js"
export * from "./ServiceBindList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__